export default "https://yastatic.net/s3/frontend/vconf-frontend/_/avatar-cacti-cactus-svgrepo-com.19b09903.svg";